<script setup lang="ts">
  import type { PropType } from 'vue'

  import { HLBadge } from '@platform-ui/highrise'

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    color: {
      type: String as PropType<
        | 'gray'
        | 'primary'
        | 'success'
        | 'error'
        | 'warning'
        | 'gray-blue'
        | 'blue-light'
        | 'blue'
        | 'indigo'
        | 'purple'
        | 'pink'
        | 'rose'
        | 'orange-dark'
      >,
      required: false,
      default: 'red',
    },
    dot: {
      type: Boolean,
      required: false,
      default: false,
    },
    max: {
      type: Number,
      required: false,
      default: undefined,
    },
    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
    showZero: {
      type: Boolean,
      required: false,
      default: false,
    },
    show: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
    offset: {
      type: Array as unknown as PropType<[number | string, number | string] | undefined>,
      required: false,
      default: undefined,
    },
    size: {
      type: String as PropType<'xs' | 'sm' | 'md' | 'lg' | '2xs' | '3xs' | 'custom'>,
      required: false,
      default: 'md',
    },
  })

  defineOptions({ inheritAttrs: false, name: 'CPBadge' })
</script>

<template>
  <HLBadge
    v-bind="$attrs"
    :id="props.id"
    :color="props.color"
    :dot="props.dot"
    :max="props.max"
    :processing="props.processing"
    :show-zero="props.showZero"
    :show="props.show"
    :value="props.value"
    :offset="props.offset"
    :size="props.size"
  >
    <slot />
    <template #value>
      <slot name="value" />
    </template>
  </HLBadge>
</template>
